import { UserService, AuthenticationError } from '../../services/user.service'
import { TokenService } from '../../services/storage.service'
import router from '../../router'

const state =  {
    authenticating: false,
    accessToken: TokenService.getToken(),
    authenticationErrorCode: 0,
    authenticationError: '', 
    refreshTokenPromise: null
}
 
const getters = {
    loggedIn: (state) => {
        return state.accessToken ? true : false
    },

    authenticationErrorCode: (state) => {
        return state.authenticationErrorCode
    },

    authenticationError: (state) => {
        return state.authenticationError
    },

    authenticating: (state) => {
        return state.authenticating
    }
}

const actions = {
    async login({ commit }, {email, password, code}) {

        commit('loginRequest');

        try {
            
            const token = await UserService.login(email, password, code);
            commit('loginSuccess', { token: token, redirect: true })

            return true
        } catch (e) {

            if (e instanceof AuthenticationError) {

                commit('loginError', {errorCode: e.errorCode, errorMessage: e.message});

            }

            return false
        }
    },

    logout({ commit }) {
        UserService.logout()
        commit('logoutSuccess')
        router.push('/login')
    },

    logoutForce({ commit }, payload) {
        UserService.logout()
        commit('logoutSuccess');
        if ( payload && payload.redirect ) {
            router.push(payload.redirect);
            return;
        }
        router.push('/login?redirect='+encodeURIComponent(window.location.pathname))
    },
    
    refreshToken({ commit, state }) {
        // If this is the first time the refreshToken has been called, make a request
        // otherwise return the same promise to the caller
        if(!state.refreshTokenPromise) {
            const p = UserService.refreshToken()
            commit('refreshTokenPromise', p)

            // Wait for the UserService.refreshToken() to resolve. On success set the token and clear promise
            // Clear the promise on error as well.
            p.then(
                response => {
                    commit('refreshTokenPromise', null)
                    commit('loginSuccess', { token: response })
                },
                error => {
                    commit('refreshTokenPromise', null)
                }
            )
        }

        return state.refreshTokenPromise
    }
}

const mutations = {
    loginRequest(state) {
        state.authenticating = true;
        state.authenticationError = ''
        state.authenticationErrorCode = 0
    },

    loginSuccess(state, {token, redirect, reload}) {
        TokenService.saveCheckLogin();
        state.accessToken = token
        state.authenticating = false;
        if ( redirect ) {
            let uri = router.history.current.query.redirect || '/';
            uri = typeof redirect === 'string' ? redirect : uri;
            if ( !!reload ) {
                window.location.assign(uri);
                return;
            }
            router.push(uri);
        }
    },

    loginError(state, {errorCode, errorMessage}) {
        state.authenticating = false
        state.authenticationErrorCode = errorCode
        state.authenticationError = errorMessage
    },

    logoutSuccess(state) {
        TokenService.removeCheckLogin();
        state.accessToken = ''
    },

    refreshTokenPromise(state, promise) {
        state.refreshTokenPromise = promise
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}